/*
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks
 * owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import { Grid, Loader, FileDrop, Card } from '@scuf/common';
import * as React from 'react';
import { TaskContext } from './TaskContext';

class TaskScan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingSettings: false,
      text: 'Processing...',
    };
  }

  componentWillUnmount() {
    const { resetResults, clearNotification } = this.context;
    resetResults(null);
    clearNotification();
  }

  onAccepted = async (fileList) => {
    const { scanTask } = this.context;
    this.toggleLoading();
    const data = new FormData();
    // get first (only) file from list
    data.append('data', fileList[0]);
    await scanTask(data);
    this.toggleLoading();
  };

  updateValue = (key, value) => {
    this.setState({ [key]: value });
  };

  toggleLoading() {
    this.setState((prevState) => ({
      loadingSettings: !prevState.loadingSettings,
    }));
  }

  fileReset() {
    const { resetResults, home } = this.context;
    resetResults(null);
    home();
  }

  render() {
    const { loadingSettings, text } = this.state;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <Loader
              loading={loadingSettings}
              overlayOpacity={0.2}
              overlayColor="#B2AFAF"
              text={text}
            >
              <div className="placeholder" />
            </Loader>
            <Card>
              <FileDrop
                acceptedTypes={['.tas']}
                placeholder="Drag and drop a Task file (.tas)"
                onAccepted={(fileList) => this.onAccepted(fileList)}
                onReset={() => this.fileReset()}
                multiple={false}
              />
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

TaskScan.contextType = TaskContext;

export default TaskScan;
